import { useSelector } from 'react-redux';
import { selectElevatorApi } from '../services/selectors';

export const useElevatorDetailApi = () => useSelector(selectElevatorApi);
